module.exports = __webpack_public_path__ + "img/6.3fe8c4b1.png";